<template>
    <div class="page" :class="{isPhonePage: isPhone}">
        <div class="base solu0">
            <ul>
                <li>电动车充电方案</li>
                <li>电动汽车有序充电方案</li>
                <li>电瓶车无人值守方案</li>
            </ul>
        </div>
        <div class="base" id="ID11">
            <div class="title-box">
                <span class="title">整体方案介绍</span>
            </div>
            <p>
                基于LoraWAN/4G等物联网技术，自主设计，研发，建立起电动汽车交流充电，电动自行车充电的新一代智能化服务管控平台。整合电瓶车充电桩，汽车交流充电
                桩，电瓶车无人值守门禁控制系统，智能有序充电，消防联动设备，环境探测，人脸识别等配套设施。再利用业务平台的运行数据建立大数据分析站，分析异常的充电行
                为。实现平台管控项目，项目反馈平台，相辅相成的一站式解决方案。
            </p>
            <img src="https://cosimg.cdbost.cn/cdboost/sy/solu1.png" alt="">
        </div>
        <div class="base" id="ID12">
            <div class="title-box">
                <span class="title">智能有序充电方案</span>
            </div>
	        <p>智能安全有序充电是实时根据社区用电负荷，自动调节新能源汽车充电，实现用电和充电有序共存。若社区负荷过高，动态降低汽车的充电功率，让负荷于民。当社区用电减少，此时动态提升充电功率。依此来动态调整社区的用电负荷，保证社区用电安全和电能效率最大化</p>
            <div class="content">
                <img src="https://cosimg.cdbost.cn/cdboost/sy/solu2.png" alt="">
            </div>
        </div>
        <div class="base" id="ID13">
            <div class="title-box">
                <span class="title">高度集成充电方案</span>
            </div>
            <p>高度集成电动车汽车智能有序充电方案、电动自行车充电方案、无人化车场方案，安全消防联动方案，打造智能管理，智慧社区。</p>
            <img src="https://cosimg.cdbost.cn/cdboost/sy/solu3.png" alt="">
        </div>
        <div class="base" id="ID14">
            <div class="title-box">
                <span class="title">电动自行车车场无人值守方案</span>
            </div>
            <p>智慧无人值守停车场，配套感知设备，实现无人值守。借助充电桩，将车场充电区、停车区有效划分。提高车场的管理。</p>
        </div>
        <div class="base" id="ID15">
            <div class="title-box">
                <span class="title">强大充电运营平台</span>
            </div>
            <img src="https://cosimg.cdbost.cn/cdboost/sy/solu5.png" alt="">
            <p>智能化服务平台，其主要思想是以物联网为基础，安全充电为目标，数据分析为核心，技术控制为手段。解决社区停车充电困扰，提升社区服务品质。平台集成运营服务，安全监测，策略控制，大数据分析，云计算等多重核心技术。助力运营商提供全方位优质服务。</p>
        </div>
        <div class="base" id="ID16">
            <div class="title-box">
                <span class="title">方案优势</span>
            </div>
            <ul :class="{isUlPhone: isPhone}">
                <li v-for="(item, index) in list" :class="'li' + index">
                    <img :src="item.img" alt="">
                    <div class="value">
                        <div class="title" :style="{color: item.color}">{{item.title}}</div>
                        <div class="text">{{item.text}}</div>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    import {getPCorPhone} from "../tools";

    export default {
        name: "solution",
        data(){
            return {
                isPhone: false,
                list: [
                    {img: ('https://cosimg.cdbost.cn/cdboost/sy/solu62.png'), color: '#2289EB', title: '独有社区智能有序充电', text: '拥有动态负荷控制、主动防护策略的发明专利，真正实现动态有序充电。'},
                    {img: ('https://cosimg.cdbost.cn/cdboost/sy/solu62.png'), color: '#22EBAB', title: '生态产品高度集成', text: '集成新能源车、电瓶车充电，项目无人值守、消防联动解决方案，一站式服务。'},
                    {img: ('https://cosimg.cdbost.cn/cdboost/sy/solu63.png'), color: '#F24343', title: '强大充电运营平台', text: '便捷体验，高度灵活的运营策略，清晰交易过程，交易实时到账，高密度的充电监测共同支撑起充电运营平台'},
                    {img: ('https://cosimg.cdbost.cn/cdboost/sy/solu64.png'), color: '#F29643', title: '智能数据分析', text: '依托于充电运行数据，自动充电异常分析，充电线路负载分析，设备故障监测，为项目运行，提供有力支撑。'},
                ]
            }
        },
        created() {
            this.isPhone = getPCorPhone();
        }
    }
</script>

<style scoped  lang="scss">
    .base {
        color: #333333;
        position: relative;
        overflow: hidden;
        background: white;
        font-size: 1em;
    }
    .solu0{
        background: url("https://cosimg.cdbost.cn/cdboost/sy/solu0.png");
        background-size: 100% 100%;
        height: 56em;
        width: 100%;
        position: relative;
        ul{
            position: absolute;
            bottom: 2em;
            left: 0;
            width: 100%;
            display: flex;
            justify-content: space-around;
            text-decoration: underline;
            font-size: 2em;
            color: #0A3056;
        }
    }
    #ID11{
        p{
            text-indent: 2em;
            font-size: 1.5em;
            line-height: 2;
            padding: 6em 4.5em 1em 4.5em;
        }
        img{
            width: calc(100% - 5em);
            padding-left: 2.5em;
        }
    }
    #ID12{
        background: #E0E8EF;
	    p{
		    text-indent: 2em;
		    font-size: 1.5em;
		    line-height: 2;
		    padding: 6em 4.5em 1em 4.5em;
	    }
        .content{
            display: flex;
            align-items: center;
            padding-bottom: 2em;
            p{
                padding: 0 1em 0 3.5em;
                font-size: 1.5em;
                line-height: 3;
                text-indent: 2em;
            }
            img{
                width: 85em;
                padding:0 2em;
            }
        }
    }
    #ID13{
        p{
            text-indent: 2em;
            font-size: 1.5em;
            line-height: 2;
            padding: 6em 4.5em 1em 4.5em;
        }
        img{
            width: calc(100% - 30em);
            padding-left: 15em;
            padding-bottom: 1em;
        }
    }
    #ID14{
        background: url("https://cosimg.cdbost.cn/cdboost/sy/solu4.png");
        background-size: 100% 100%;
        height: 65em;
        width: 100%;
        position: relative;
        p{
            padding: 6em 6.5em 0 6.5em;
            font-size: 1.5em;
            line-height: 1.5;
            text-indent: 2em;
        }
    }
    #ID15{
        img{
            width: calc(100% - 25em);
            padding: 6em 12.5em 0 12.5em;
        }
        p{
            font-size: 1.5em;
            line-height: 2;
            padding: 1em 4em;
            text-indent: 2em;
        }
    }
    #ID16{
        background: #E0E8EF;
        ul{
            padding: 11em 3em;
            width: calc(100% - 6em);
            display: flex;
            flex-wrap: wrap;
            li{
                background: white;
                width: calc(50% - 0.5em);
                height: 18em;
                border-radius: 0.5em;
                display: flex;
                align-items: center;
                img{
                    width: 13.75em;
                    height: 13em;
                    margin: 0 3.75em;
                }
                .value{
                    margin: 2em;
                    line-height: 2;
                }
                .title{
                    font-size: 2em;
                }
                .text{
                    font-size: 1.5em;
                }
            }
            .li0{
                margin: 0 1em 1em 0;
            }
            .li2{
                margin-right: 1em;
            }
        }
        .isUlPhone{
            padding: 11em 5em;
            width: calc(100% - 10em);
            li{
                width: 100%;
                margin: 0.5em;
                height: 22em;
                .value{
                    line-height: 1;
                }
                .title{
                    font-size: 13px;
                }
                .text{
                    font-size: 12px;
                    line-height: 1.5;
                }
            }
        }
    }
    .isPhonePage{
        .title-box{
            font-size: 3.5rem;
            padding-top: 1rem;
            .title{
                position: relative;
                &:after{
                    content: '';
                    background: #1B5AA7;
                    position: absolute;
                    bottom: 0rem;
                    height: 0.5rem;
                    width: 100%;
                    left: 0;
                    border-radius: 0.5rem;
                }
            }
        }
        .solu0 li{
            font-size: 12px;
        }
        #ID11 p, #ID13 p, #ID15 p{
            font-size: 12px;
            padding: 2em 1em 1em 1em;
        }
        #ID12{
            text-align: center;
            .content {
                display: block;
                padding-top: 10em;
                padding-bottom: 2em;
            }
            img{
                margin: 0 auto;
            }
            p{
                font-size: 12px;
                line-height: 2;
                padding: 0 0 0 1em;
                text-align: left;
            }
        }
        #ID14 p{
            font-size: 12px;
            padding: 2em 1em 1em 1em;
            line-height: 1.5;
        }
        #ID15 img{
            width: calc(100% - 5em);
            padding: 6em 2.5em 0 2.5em;
        }
    }
</style>